import React from 'react';
import {
    HiddenCheckbox,
    StyledCheckbox,
    CheckboxContainer,
    Icon,
} from './style';

const CheckboxInput = ({
    className,
    checked,
    label,
    isChecked,
    setChecked,
    ...props
}) => (
	<CheckboxContainer
		className={className}
	>
		<HiddenCheckbox checked={isChecked} {...props} />
		<StyledCheckbox
			checked={isChecked}
			onClick={setChecked}
			id="term-checkbox"
		>
			<Icon viewBox="0 0 20 20">
				<polyline points="2 8 8 13 16 1" />
			</Icon>
		</StyledCheckbox>
		<label>{label}</label>
	</CheckboxContainer>
    );

export default CheckboxInput;
